import { render, staticRenderFns } from "./ViewerPdfField.vue?vue&type=template&id=2feba698&scoped=true&"
import script from "./ViewerPdfField.vue?vue&type=script&lang=js&"
export * from "./ViewerPdfField.vue?vue&type=script&lang=js&"
import style0 from "./ViewerPdfField.vue?vue&type=style&index=0&id=2feba698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feba698",
  null
  
)

export default component.exports